import { render, staticRenderFns } from "./CampusCardPayment.vue?vue&type=template&id=5e04ba75&scoped=true&"
import script from "./CampusCardPayment.vue?vue&type=script&lang=js&"
export * from "./CampusCardPayment.vue?vue&type=script&lang=js&"
import style0 from "./CampusCardPayment.vue?vue&type=style&index=0&id=5e04ba75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e04ba75",
  null
  
)

export default component.exports